/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a PCR master mix?`)
};

const es_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es un master mix de PCR?`)
};

const de_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist ein PCR-Mastermix?`)
};

const nl_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een PCR-mastermix?`)
};

const fr_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'un mix maître PCR ?`)
};

const it_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un master mix PCR?`)
};

const pt_br2_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um master mix de PCR?`)
};

const pt_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma master mix de PCR?`)
};

const ja_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCRマスターミックスとは何ですか?`)
};

const zh_pcr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 PCR 混合液？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_q1", locale)
	if (locale === "en") return en_pcr_faq_q1(inputs)
	if (locale === "es") return es_pcr_faq_q1(inputs)
	if (locale === "de") return de_pcr_faq_q1(inputs)
	if (locale === "nl") return nl_pcr_faq_q1(inputs)
	if (locale === "fr") return fr_pcr_faq_q1(inputs)
	if (locale === "it") return it_pcr_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_q1(inputs)
	if (locale === "pt") return pt_pcr_faq_q1(inputs)
	if (locale === "ja") return ja_pcr_faq_q1(inputs)
	return zh_pcr_faq_q1(inputs)
};